import { routes } from 'commons/constants/routes'
import { DateTime, Link, TableColumn } from 'ui/components'
import { CheckMark } from '~bank-reports/components/CheckMark'

import { DocumentStatusItem } from '../../types'

export const columns = (availableSortFields?: string[]): TableColumn<DocumentStatusItem>[] => [
  {
    title: 'Document Name',
    key: 'documentName',
    align: 'left',
    sortable: availableSortFields?.includes('documentName'),
    render: ({ documentName, documentId }) => (
      <>
        {documentName && documentId && (
          <Link to={routes.bank.documents.details} params={{ documentId: documentId.toString() }}>
            {documentName}
          </Link>
        )}
      </>
    )
  },
  {
    title: 'Relationship Name',
    key: 'showRelationshipName',
    align: 'left',
    sortable: availableSortFields?.includes('showRelationshipName'),
    render: ({ showRelationshipName, showRelationshipId }) => (
      <>
        {showRelationshipName && showRelationshipId && (
          <Link to={routes.bank.relationships.details} params={{ id: showRelationshipId.toString() }}>
            {showRelationshipName}
          </Link>
        )}
      </>
    )
  },
  {
    title: 'Contact Name',
    key: 'showContactName',
    align: 'left',
    sortable: availableSortFields?.includes('showContactName'),
    render: ({ showContactName, showContactId }) => (
      <>
        {showContactName && showContactId && (
          <Link to={routes.bank.contacts.details} params={{ contactId: showContactId.toString() }}>
            {showContactName}
          </Link>
        )}
      </>
    )
  },
  {
    title: 'Is Accepted',
    key: 'isAccepted',
    sortable: availableSortFields?.includes('isAccepted'),
    render: ({ isAccepted }) => <CheckMark active={isAccepted} />
  },
  {
    title: 'Last Accepted At',
    key: 'showLastAcceptedAt',
    sortable: availableSortFields?.includes('showLastAcceptedAt'),
    render: ({ showLastAcceptedAt }) => showLastAcceptedAt && <DateTime date={showLastAcceptedAt} />
  },
  {
    title: 'Created At',
    key: 'showLastAcceptedPeriodCreatedAt',
    sortable: availableSortFields?.includes('showLastAcceptedPeriodCreatedAt'),
    render: ({ showLastAcceptedPeriodCreatedAt }) =>
      showLastAcceptedPeriodCreatedAt && <DateTime date={showLastAcceptedPeriodCreatedAt} />
  },
  {
    title: 'Updated At',
    key: 'showLastAcceptedPeriodUpdatedAt',
    sortable: availableSortFields?.includes('showLastAcceptedPeriodUpdatedAt'),
    render: ({ showLastAcceptedPeriodUpdatedAt }) =>
      showLastAcceptedPeriodUpdatedAt && <DateTime date={showLastAcceptedPeriodUpdatedAt} />
  }
]
